module.exports = __webpack_public_path__ + "img/yuni-sit.f3a52198.png";